import { cloud, moon } from '../motifs';
import { M, WHITE } from '../palette';
import { registerPlate } from '../registry';

const MOON = ['#fffbea', '#ece6d0', '#c4bca4'] as const;

/** 03 เซียน: the immortal's plate, deep blue under a pale moon, clouds curling round both ends. */
registerPlate({
  id: 'immortal',
  name: 'เซียน',
  ground: ['#34508a', '#1e3260', '#14213e'],
  trim: M.goldLo,
  text: { fill: [M.whiteHi, '#c8d4f0'], line: '#0c1428' },
  inset: [14, 14],
  back(p, f) {
    moon(p, f.x + 11, f.y - 4, 10, MOON);
  },
  front(p, f) {
    cloud(p, f.x - 11, f.b + 5, 24, WHITE);
    cloud(p, f.x - 5, f.y + 9, 14, WHITE);
    cloud(p, f.r - 15, f.b + 6, 26, WHITE, true);
    cloud(p, f.r - 3, f.y + 8, 14, WHITE, true);
  },
  motion: {
    sprites: {
      wisp: { w: 12, h: 8, draw: (p) => cloud(p, 0, 8, 12, WHITE) },
    },
    play(a, t, f) {
      // Two small clouds drifting slowly back and forth along the ends.
      a.spr('wisp', f.x + 14 + Math.sin(t * 0.6) * 3, f.y - 6);
      a.spr('wisp', f.r - 22 + Math.sin(t * 0.5 + 2) * 3, f.b - 2);
    },
  },
});
